import type { AppDispatch, RootState } from "app/store";
import { ObjectVisibility, renderActions, selectDefaultVisibility } from "features/render";

/**
 * Turns off the x-ray the object-to-object tool switched on.
 *
 * X-ray is an affordance for measuring - it makes the measured pair stand out of the model around
 * it - so it belongs to the tool and not to the view: leaving the tool, or resetting it, should not
 * leave the whole model see-through.
 */
export function turnOffObjectMeasureXray(dispatch: AppDispatch, state: RootState) {
    if (selectDefaultVisibility(state) === ObjectVisibility.Xray) {
        dispatch(renderActions.setVisibilityMode(ObjectVisibility.Neutral));
    }
}
